import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=2856a60b&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"
import style0 from "./Bill.vue?vue&type=style&index=0&id=2856a60b&prod&scoped=true&lang=css"
import style1 from "./Bill.vue?vue&type=style&index=1&id=2856a60b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856a60b",
  null
  
)

export default component.exports